import '../privacypolicy.css';

const PrivacyPolicy = () => (
  <div className="privacy-container">
    <h1 className="privacy-title">Privacy Policy</h1>
    <div className="privacy-text">
      <h2 className="privacy-subtitle">Your Privacy Matters</h2>
      <p>
        Capital Beaver Enterprise Inc. is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use Kierep.
      </p>
      <h2 className="privacy-subtitle">Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, company details, and usage data to provide and improve our services.
      </p>
      <h2 className="privacy-subtitle">How We Use Your Information</h2>
      <p>
        Your information is used to operate, maintain, and enhance our platform, communicate with you, and comply with legal obligations.
      </p>
      <h2 className="privacy-subtitle">Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your data from unauthorized access, disclosure, or destruction.
      </p>
      <h2 className="privacy-subtitle">Your Rights</h2>
      <p>
        You have the right to access, update, or delete your personal information. Contact us at ceo@kierep.com for any requests.
      </p>
      <h2 className="privacy-subtitle">Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at ceo@kierep.com.
      </p>
    </div>
  </div>
);

export default PrivacyPolicy;
